import React from "react";
import VehicleCard from "./VehicleCard";
import { computePrice } from "../../utils/pricing";
import { vehicles } from "../../data/vehicles";


export default function VehicleList({ dateRange }) {
 
  
  const fromISO = dateRange?.from || "";
  const toISO = dateRange?.to || "";

  

  return (
    <section className="container mx-auto px-6 pb-14">
      <div className="mt-6 space-y-6">
        {vehicles.map((v) => {
          const pricing = computePrice({
            fromISO,
            toISO,
            weekDayPerDay: v.pricing.weekDayPerDay,
            weekendPerDay: v.pricing.weekendPerDay,
          });

          console.log(`💰 Prix calculé pour ${v.title}:`, pricing);

          return <VehicleCard key={v.id} vehicle={v} pricing={pricing} />;
        })}
      </div>
    </section>
  );
}